import apiClient from './axiosClient'

// Authentication APIs
export const loginAPI = (username, password) => {
  return apiClient.post('/insurance/auth/login', { username, password })
}

export const loginUser = loginAPI  // Keep backward compatibility

export const refreshToken = (refreshToken) => {
  return apiClient.post('/insurance/auth/refresh', { refresh_token: refreshToken })
}

export const logoutUser = () => {
  return apiClient.post('/insurance/auth/logout')
}

// Patient APIs
export const searchPatients = (params = {}) => {
  return apiClient.get('/insurance/patient', { params })
}

export const getPatient = (patientId) => {
  return apiClient.get(`/insurance/patient/${patientId}`)
}

export const createPatient = (patientData) => {
  return apiClient.post('/insurance/patient', patientData)
}

export const updatePatient = (patientId, patientData) => {
  return apiClient.put(`/insurance/patient/${patientId}`, patientData)
}

export const deletePatient = (patientId) => {
  return apiClient.delete(`/insurance/patient/${patientId}`)
}

export const getPatientAudit = (patientId) => {
  return apiClient.get(`/insurance/patient/${patientId}/audit`)
}

// Integration APIs (Search & Pull from Main System)
export const searchMainSystem = (searchParams) => {
  return apiClient.post('/insurance/integration/search', searchParams)
}

export const pullPatientFromMain = (patientId) => {
  return apiClient.get(`/insurance/integration/patient/${patientId}`)
}

// Admin APIs
export const listUsers = (params = {}) => {
  return apiClient.get('/insurance/admin/users', { params })
}

export const createUser = (userData) => {
  return apiClient.post('/insurance/admin/users', userData)
}

export const updateUser = (userId, userData) => {
  return apiClient.put(`/insurance/admin/users/${userId}`, userData)
}

export const deleteUser = (userId) => {
  return apiClient.delete(`/insurance/admin/users/${userId}`)
}

export const getStatistics = () => {
  return apiClient.get('/insurance/admin/stats')
}

// Center APIs
export const getCenters = () => {
  return apiClient.get('/insurance/centers')
}

// Receipt Management APIs
export const receiptAPI = {
  // Get all receipts for a patient with filters and pagination
  getPatientReceipts: (patientId, params = {}) => {
    return apiClient.get(`/insurance/patients/${patientId}/receipts`, { params })
  },

  // Download receipt PDF
  downloadReceipt: async (receiptId) => {
    const response = await apiClient.get(`/insurance/receipts/${receiptId}/download`, {
      responseType: 'blob'
    })
    return response.data
  },

  // Update receipt
  updateReceipt: (receiptId, receiptData) => {
    return apiClient.put(`/insurance/receipts/${receiptId}`, receiptData)
  },

  // Soft delete receipt
  deleteReceipt: (receiptId, reason) => {
    return apiClient.delete(`/insurance/receipts/${receiptId}`, {
      data: { reason }
    })
  },

  // Restore soft deleted receipt
  restoreReceipt: (receiptId) => {
    return apiClient.post(`/insurance/receipts/${receiptId}/restore`)
  },

  // Get receipt details
  getReceiptDetails: (receiptId) => {
    return apiClient.get(`/insurance/receipts/${receiptId}/details`)
  }
}

// Export individual receipt functions for backward compatibility
export const getPatientReceipts = receiptAPI.getPatientReceipts
export const downloadReceipt = receiptAPI.downloadReceipt
export const updateReceipt = receiptAPI.updateReceipt
export const deleteReceipt = receiptAPI.deleteReceipt
export const restoreReceipt = receiptAPI.restoreReceipt

